import { externalLinks } from 'lib/consts/externalLinks'
import { getMailtoHref } from 'lib/navigation/helpers/getMailtoHref/getMailtoHref'
import { t } from 'lib/translations/i18next'
import * as clipboard from 'lib/clipboard'
import { useSnackbarsStore } from 'settle-ui/hooks/useSnackbarsStore/useSnackbarsStore'
import { INTERCOM_CUSTOM_LAUNCHER_ID } from 'routes/components/AppLayout/components/AppLayoutContent/components/StickyButtonTray/components/IntercomCustomLauncherFab/IntercomCustomLauncherFab'

export type ContactMethod = 'email' | 'Intercom'

export interface OpenSupportContactParams {
  subject?: string
  message?: string
  afterContact?: (method: ContactMethod) => void
}

export const mailToSupport = ({ subject, message }: Pick<OpenSupportContactParams, 'subject' | 'message'>) => {
  const mailto = getMailtoHref({ to: externalLinks.supportEmail, subject, body: message })

  window.open(mailto, '_blank', 'noopener,noreferrer')
}

const handleEmailFallback = async (params: OpenSupportContactParams) => {
  const { subject, message, afterContact } = params

  mailToSupport({ subject, message })
  afterContact?.('email')

  const clipboardSucceeded = await clipboard.write(externalLinks.supportEmail)

  const snackbarMessage = clipboardSucceeded
    ? t('openSupportContact::chatUnavailableEmailCopied')
    : t('openSupportContact::chatUnavailableEmail')

  useSnackbarsStore.getState().showAlert(snackbarMessage, { timeout: 15000 })
}

export const openSupportContact = async (params: OpenSupportContactParams) => {
  const isIntercomAvailable = document.getElementById(INTERCOM_CUSTOM_LAUNCHER_ID) !== null

  if (!isIntercomAvailable) {
    await handleEmailFallback(params)
    return
  }

  try {
    window.Intercom('startConversation', params.message ?? params.subject)
    params.afterContact?.('Intercom')
  } catch {
    await handleEmailFallback(params)
  }
}
